import { otto } from "@gr-exports/async/nexus";
import { onLoad, onReady } from "@gr-exports/async/dom";
import { defineEvent } from "@gr-common/async/nexus";
import { events } from "@gr-exports/async/event-q-bus";
import { trackLegacySelectors } from "./async/tracking";
import { hardcoreLegacy, insertHtmlFragment } from "./async/fragment";
import { initializeMountingHooks, onMount, onUnmount } from "./async/hooks";
import type { EventLoaderEvents } from "../event-loader";

/*                                   */
otto.dom.assignNamespace(
  {
    onLoad: defineEvent(),
    onReady: defineEvent(),
    onMount,
    onUnmount,
    insertHtmlFragment,
    activateInlineScripts: hardcoreLegacy.activateInlineScripts,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

/*                                                 */
const legacy = events<EventLoaderEvents>();
legacy.once("assets.events.documentReady", (e) => onReady.set(e));
legacy.once("assets.events.windowLoad", (e) => onLoad.set(e));

/*                    */
initializeMountingHooks();
onLoad.sub(trackLegacySelectors);
